
import {  Flex } from "@chakra-ui/react";
import { BilhetePagamento } from "../../hooks/pagamento/usePedido";
import { DetalhesBilhete } from "./DetalhesBilhete";

interface Props {
  bilhetes: BilhetePagamento;
  showCancel?: boolean;
  agenciaRepassaMulta?: boolean;
  multaNaFatura?: boolean;
}

export function Bilhetes({
  bilhetes,
  showCancel = true,
  agenciaRepassaMulta = false,
  multaNaFatura = false,
}: Props) {
  return (
    <Flex gap={2} direction={'column'}>
      {'ida' in bilhetes && bilhetes.ida.map((servico) => (
        servico.viagens.map((detalhes) => (
          <DetalhesBilhete
            contexto={'ida'}
            detalhe={detalhes}
            showCancel={showCancel}
            agenciaRepassaMulta={agenciaRepassaMulta}
            multaNaFatura={multaNaFatura}
          />
        ))
      ))}
      {'volta' in bilhetes && bilhetes.volta.map((servico) => (
        servico.viagens.map((detalhes) => (
          <DetalhesBilhete
            contexto={'volta'}
            detalhe={detalhes}
            showCancel={showCancel}
            agenciaRepassaMulta={agenciaRepassaMulta}
            multaNaFatura={multaNaFatura}
          />
        ))
      ))}
    </Flex>
  );
}
